export const currentFolderScope = "tN3fuc";
export const recursiveFolderScope = "iYLled";
export const favoritesFolderScope = "vN9ucb";
export default {currentFolderScope,recursiveFolderScope,favoritesFolderScope};